<template>
  <div class="index-menu">
    <el-card>
      <div class="card-title">个人中心</div>
      <div class="card-user">
        <div class="user-pic">
          <img :src="avatarUrl" />
        </div>
        <div class="user-info">
          <div class="user-name">
            <span>欢迎您</span>
            <span style="font-weight: bold;padding-left: 6px;">{{ userName }}</span>
          </div>
          <div>
            <router-link to="/user/index" class="user-opera">管理账户信息</router-link>
          </div>
        </div>
      </div>
      <div class="index-menu">
        <el-menu router :default-active="$route.path">
          <el-menu-item index="/order/index">
            <span>我的订单</span>
            <el-badge :value="clientStatistics.purchaseOrderCount" class="menu-num" type="primary"/>
          </el-menu-item>
          <el-menu-item index="/cart">
            <span>我的购物车</span>
            <el-badge :value="clientStatistics.purchaseShoppingCount" class="menu-num" type="success"/>
          </el-menu-item>
          <el-menu-item index="/user/favourite/list">
            <span>我的常用物料</span>
            <el-badge :value="clientStatistics.favoriteItemCount" class="menu-num" type="warning"/>
          </el-menu-item>
          <el-menu-item index="/user/address/list">
            <span>地址管理</span>
            <el-badge :value="clientStatistics.addressBookCount" class="menu-num" type="info"/>
          </el-menu-item>
          <!-- <el-menu-item v-if="isRTM" index="/user/client/list">
            <span>人员管理</span>
            <el-badge class="menu-num" type="info"/>
          </el-menu-item> -->
        </el-menu>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import userApi from '@/api/user'
import { commonUtils } from '@/utils/common'
export default {
  data () {
    return {
      userName: '',
      clientStatistics: {
        purchaseOrderCount: 0,
        purchaseShoppingCount: 0,
        favoriteItemCount: 0,
        addressBookCount: 0
      },
      isRTM: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    avatarUrl () {
      const defaultAvatar = require('../../../assets/images/default-avatar.png')
      return commonUtils.getImageUrl(this.userInfo.avatarImageUri, defaultAvatar)
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.userName = this.userInfo.clientName
      this.isRTM = this.userInfo.employeeLevel === 50
      this.queryClientStatistics()
    },

    queryClientStatistics () {
      userApi.queryStatistics().then(res => {
        if (res.data.resultCode === '0') {
          this.clientStatistics = res.data.resultData.clientStatistics
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.index-menu {
  ::v-deep .el-card__body {
    padding: 0;
  }

  ::v-deep .el-menu-item {
    height: 50px;
    line-height: 50px;
    color: #000;
    border-bottom: 1px solid #dee2ed;
  }
}

.el-card {
  height: 620px;
  .card-title {
    padding: 18px;
    font-size: $font-14;
  }
  .card-user {
    height: 120px;
    background-color: $base-blue;
    display: flex;
    align-items: center;
    .user-pic {
      width: 80px;
      height: 80px;
      margin-left: $content-large;
      margin-right: $content-large;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .user-info {
      color: $base-white;
      .user-name {
        font-size: $font-16;
        margin-bottom: 10px;
      }
      .user-opera {
        color: $base-white;
        font-size: $font-12;
      }
    }
  }
  .index-menu {
    font-size: $font-14;
    .menu-num {
      margin-top: 5px;
      position: absolute;
      right: 30px;
    }
  }
}
</style>
